//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import i18n from '@/scripts/libs/i18n'

export default {
  name: 'rb-payment-message-box-wrapper',
  computed: {
    ...mapGetters(['showPaymentMessageBox']),
  },
  created() {
    i18n.loadTranslationsBySection('payment-message-box')
  },
}
